import { colors } from 'src/components/base';

const DEFAULTS = {
  Dark: colors.lightTheme.base900,
  Light: colors.lightTheme.base0,
  White: colors.lightTheme.base0,
  'Light grey': colors.lightTheme.base100,
  'Primary blue': colors.lightTheme.maybeBlue500,
  'Light blue': colors.lightTheme.maybeBlue100,
  'Dark blue': colors.lightTheme.maybeBlue900,
};

const backgroundColor = (color: string | null) => {
  if (!color || ['Dark', 'Light'].includes(color)) return 'inherit';

  return DEFAULTS[color];
};

const textColor = (color: string | null) => {
  if (!color) return 'inherit';

  if (['Dark', 'Light'].includes(color)) return DEFAULTS[color];
  if (['Primary blue', 'Dark blue'].includes(color))
    return colors.lightTheme.base0;

  return 'inherit';
};

const linkColor = (color: string | null) => {
  if (color && ['Primary blue', 'Dark blue'].includes(color))
    return colors.lightTheme.maybeBlue300;

  return colors.lightTheme.maybeBlue700;
};

const colorMap = (color: string | null) => {
  return {
    bg: backgroundColor(color),
    text: textColor(color),
    link: linkColor(color),
  };
};

export default colorMap;
